import React from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type TagBadgeProps = React.ComponentProps<typeof Badge>;

export function TagBadge({
  className,
  variant = "secondary",
  ...props
}: TagBadgeProps) {
  return (
    <Badge
      variant={variant}
      className={cn("dark:bg-secondary bg-[rgba(0,0,0,0.05)]", className)}
      {...props}
    />
  );
}
